<template>
  <div class="product-grid">
    <div v-if="loading" class="product-grid-loading">
      <ProductCardLoader v-for="i in 4" :key="`first-${i}`" />
      <ProductCardLoader v-for="i in 4" :key="`second-${i}`" />
      <ProductCardLoader v-for="i in 4" :key="`third-${i}`" />
    </div>
    <template v-else>
      <div v-show="isDesktop" class="title-and-sort">
        <div class="title">
          <h4 class="title">{{ title }}</h4>
          <span v-if="$route.name != 'OurCuratedSelections'" class="subtitle">{{ lists_count }} Products</span>
        </div>
        <div class="sort">
          <span>Sort by</span>
          <select v-model="sort.value" class="form-control show-sort" @change="applySort(sort.value)">
            <option value="" disabled>-</option>
            <option v-for="(item, i) in sort.options" :key="`sorts-list-${i}`" :value="item.query">
              {{ item.label }}
            </option>
          </select>
        </div>
      </div>
      <div
        v-show="!isDesktop"
        :id="!isDesktop ? 'sticky_sortby' : ''"
        :class="{ 'sticky box-shadow': isScroll }"
        class="header-filter"
        :style="`top:${scrollTop}px;`"
        @scroll="stickySortBy"
      >
        <ul class="tabs header-filter__tabs">
          <li
            class="tabs__item tabs__item__header-filter"
            :class="{
              actived: isFilterActive,
            }"
          >
            <a href="" @click.prevent="showFilter()">
              <img
                v-if="isFilterActive"
                src="/assets/img/icon-filter-revamp-active.svg"
                class="icon-filter"
                width="12"
                height="12"
                alt="Filter icon"
              />
              <img
                v-else
                src="/assets/img/icon-filter-revamp.svg"
                class="icon-filter"
                width="12"
                height="12"
                alt="Filter icon"
              />
              <span :class="{ 'filter-active': true, active: isFilterActive }">
                {{ isFilterActive ? 'Filtered' : 'Filter' }}
              </span>
            </a>
          </li>
          <li
            class="tabs__item tabs__item__header-filter"
            :class="{
              active: queryString.sort === '-six_month_total_orders',
            }"
          >
            <a href="" @click.prevent="applySort('-six_month_total_orders')">Terlaris</a>
          </li>
          <li
            class="tabs__item tabs__item__header-filter"
            :class="{
              active: queryString.sort === '-review_stats.total_reviews',
            }"
          >
            <a href="" @click.prevent="applySort('-review_stats.total_reviews')">Review</a>
          </li>
          <li
            class="tabs__item tabs__item__header-filter tabs__item__header-filter--with-caret"
            :class="{
              active: queryString.sort === filterPrice,
              up: filterPrice === 'default_combination.price_after_discount',
              down: filterPrice === '-default_combination.price_after_discount',
            }"
          >
            <a href="" class="filter-price" @click.prevent="toggleSortProductByPrice(filterPrice)">{{
              copywritingFilterPrice
            }}</a>
          </li>
          <li
            class="tabs__item tabs__item__header-filter"
            :class="{
              active: queryString.sort === 'newest',
            }"
          >
            <a href="" @click.prevent="applySort('newest')">Terbaru</a>
          </li>
          <li
            class="tabs__item tabs__item__header-filter tabs__item__header-filter--with-caret"
            :class="{
              active: queryString.sort === filterName,
              up: filterName === 'name',
              down: filterName === '-name',
            }"
          >
            <a href="" class="filter-ordering" @click.prevent="toggleSortProductByName(filterName)">{{
              copywritingFilterName
            }}</a>
          </li>
        </ul>
        <div class="all-products">
          <a href="" @click.prevent="showFilterCategory = true">
            <p class="subtitle">
              All Products
              <span v-if="$route.name != 'OurCuratedSelections'" class="total-product">({{ lists_count }}) </span>
              <img src="/assets/img/arrow-down-grey.svg" class="icon" width="12" height="12" alt="Filter icon" />
            </p>
          </a>
        </div>
      </div>
      <div v-if="products && products.length" class="products">
        <GProduct
          v-for="(product, key) in products"
          :key="`product-${key}`"
          :inline-reviewers="true"
          :button-review="true"
          :product="product"
        />
        <infinite-loading
          v-if="Number(lists_count) > Number(queryString.limit)"
          @infinite="(data) => $emit('infiniteHandler', data)"
        >
          <div slot="no-more"></div>
          <div slot="no-results"></div>
          <div slot="spinner">
            <div class="text-center">
              <div v-if="loading" class="product-grid-loading">
                <GFMP v-for="i in 16" :key="i" :styles="{ height: '210px', width: '191px' }" />
              </div>
            </div>
          </div>
        </infinite-loading>
      </div>
      <div v-else class="products-empty">
        <img
          v-if="isDesktop"
          src="/assets/img/icons/product-not-found.svg"
          name="product-not-found"
          alt=""
          width="151"
          height="151"
        />
        <img
          v-else
          src="/assets/img/icons/product-not-found.svg"
          name="product-not-found"
          alt=""
          width="80"
          height="80"
        />
        <p class="text">Maaf, tidak ada produk yang ditemukan</p>
        <button type="button" class="btn btn--black" @click.prevent="reset()">Reset filter</button>
      </div>
    </template>
    <g-modal v-if="showFilterCategory && categories" id="pills-dropdown-mobile" class="normalize-gutter">
      <template slot="header">
        <div class="rectangle-top"></div>
        <div class="modal-heading">
          <h4 class="modal-heading--title">Select Category</h4>
          <button
            type="button"
            class="close modal-heading--close"
            data-dismiss="modal"
            aria-label="Close"
            @click="showFilterCategory = false"
          >
            <img src="/assets/img/icon-close.svg" height="14" width="14" />
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="filter-categories">
          <ul class="parent-category">
            <li
              :class="{
                highlighted: highlightAllProducts,
              }"
              @click.prevent="removeFilterCategory"
            >
              All Products
            </li>
            <li
              v-for="(category, index) in categories"
              :key="category && category._id"
              @click.prevent="onCategoryClick(index, '')"
            >
              <span>{{ category.name }}</span>
              <ul
                v-if="category.children && category.children.length"
                class="parent-category child-category"
                :class="{ active: index === activeCategoryIndex }"
              >
                <li
                  :class="{
                    highlighted: checkIsHighlighted(category),
                  }"
                  @click.prevent="onCategoryClick('', category)"
                >
                  <span>All {{ category.name }}</span>
                </li>
                <li
                  v-for="childCategory in category.children"
                  :key="childCategory && childCategory._id"
                  :class="{
                    highlighted: checkIsHighlighted(childCategory),
                  }"
                >
                  <a href="javascript:" @click.prevent="onCategoryClick('', childCategory)">
                    <span>{{ childCategory.name }}</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </template>
    </g-modal>
  </div>
</template>

<script>
export default {
  name: 'ProductGrid',
  components: { ProductCardLoader: () => import('../global/loader/product-card-loader') },
  props: {
    products: {
      type: Array,
      required: true,
      default: () => [],
    },
    title: {
      type: String,
      default: 'All Products',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    lists_count: {
      default: 0,
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      sort: {
        value: null,
        options: [
          { label: 'Terlaris', query: '-six_month_total_orders', value: 'most-purchased' },
          { label: 'Review', query: '-review_stats.total_reviews', value: 'most-reviewed' },
          {
            label: 'Produk Terbaru - Terlama',
            query: '-created_at',
            value: 'newest',
          },
          {
            label: 'Produk Terlama - Terbaru',
            query: 'created_at',
            value: 'oldest',
          },
          {
            label: 'Harga Rendah - Tinggi',
            query: 'default_combination.price_after_discount',
            value: 'cheapest',
          },
          {
            label: 'Harga Tinggi - Rendah',
            query: '-default_combination.price_after_discount',
            value: 'expensive',
          },
          { label: 'A - Z', query: 'name', value: 'asc' },
          { label: 'Z - A', query: '-name', value: 'desc' },
        ],
      },
      filterName: 'name',
      filterPrice: 'default_combination.price_after_discount',
      isScroll: false,
      scrollTop: 0,
      bottom: 0,
      showFilterCategory: false,
      activeCategoryIndex: null,
      activeChildCategory: false,
    };
  },
  computed: {
    isFilterActive() {
      return (
        this.$store.state.modal.isModalShow.filterV2 ||
        this.queryString.category ||
        this.queryString.brands ||
        this.queryString.origins ||
        this.queryString.rating ||
        this.queryString.available_for
      );
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    queryString() {
      return this.$store.state.$_Review.queryString;
    },
    category() {
      return this.$store.state.$_Category.categories.data;
    },
    copywritingFilterName() {
      if (this.filterName === 'name') {
        return 'A - Z';
      } else {
        return 'Z - A';
      }
    },
    copywritingFilterPrice() {
      if (this.filterPrice === 'default_combination.price_after_discount') {
        return 'Harga Rendah - Tinggi';
      } else {
        return 'Harga Tinggi - Rendah';
      }
    },
    categories() {
      let result;
      if (this.$route.name === 'BrandDetail') {
        result = this.$store.state['$_Brand'].categories;
      } else if (this.$route.name === 'Category') {
        result = this.$store.state['$_Category'].grandParent.children;
      } else {
        result = this.$store.state['$_Review'].categories;
      }
      return result && result.length ? result : null;
    },
    highlightAllProducts() {
      if (this.$route.name !== 'Category') {
        if (!this.queryString.category) {
          return true;
        }
      } else if (this.$route.name == 'Category' && this.category.parents.length == 1) {
        return true;
      }
      return false;
    },
  },
  watch: {
    loading: {
      handler(val, old) {
        this.$nextTick(() => {
          const sortby = document.getElementById('sticky_sortby');
          if (sortby) {
            const { top } = sortby.getBoundingClientRect();
            this.bottom = top - 60;
          }
        });
      },
      immediate: true,
    },
    // '$route.path'() {
    //   Object.entries(this.$options.data()).forEach(([key, value]) => (this[key] = value));
    //   this.$route.query = {};
    // },
  },
  mounted() {
    window.addEventListener('scroll', this.stickySortBy);
  },
  destroyed() {
    window.removeEventListener('scroll', this.stickySortBy);
  },
  methods: {
    toggleSortProductByName(sortName) {
      this.filterName =
        this.queryString.sort === 'name' ? '-name' : this.queryString.sort === '-name' ? 'name' : this.filterName;
      let value = '';
      if (this.filterName === 'name') {
        value = 'name';
      } else {
        value = '-name';
      }
      this.applySort(value);
    },
    toggleSortProductByPrice(sortName) {
      this.filterPrice =
        this.queryString.sort === 'default_combination.price_after_discount'
          ? '-default_combination.price_after_discount'
          : this.queryString.sort === '-default_combination.price_after_discount'
          ? 'default_combination.price_after_discount'
          : this.filterPrice;
      let value = '';
      if (this.filterPrice === 'default_combination.price_after_discount') {
        value = 'default_combination.price_after_discount';
      } else {
        value = '-default_combination.price_after_discount';
      }
      this.applySort(value);
    },
    stickySortBy(e) {
      if (!this.isDesktop) {
        try {
          const header = document.getElementById('main_header__v2');
          if (this.bottom > 0 && window.scrollY > this.bottom) {
            this.isScroll = true;
            this.scrollTop = header.offsetHeight;
          } else {
            this.isScroll = false;
            this.scrollTop = 0;
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        this.isScroll = false;
      }
    },
    applySort(sortName) {
      let sortValue;
      let query;
      if (this.$store.state.$_Review.queryString.sort === sortName) {
        sortValue = '';
      } else {
        sortValue = sortName;
      }
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'sort',
        value: sortValue,
      });
      query = Object.assign({}, this.$route.query);
      if (sortValue) {
        query = Object.assign(query, { sort: sortValue });
      } else {
        if (query.sort) {
          delete query.sort;
        }
      }
      if (query.page) {
        query.page = 1;
      }
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'skip',
        value: 0,
      });
      this.$router.push({ query: query });
    },
    showFilter() {
      this.$store.commit('toggleModalGlobalState', {
        modalName: 'filterV2',
      });
    },
    onCategoryClick(index, data) {
      this.activeCategoryIndex = this.activeCategoryIndex === index ? null : index;
      if (data) {
        if (this.$route.name === 'Category') {
          this.$router.push(`/category/${data.my_soco_sql_id}/${data.link_rewrite}`);
        } else {
          this.$store.commit('$_Review/SET_QUERY_STRING', {
            name: 'category',
            value: data._id,
          });
        }
        this.showFilterCategory = false;
      }
    },
    removeFilterCategory() {
      const query = Object.assign({}, this.$route.query);
      if (this.queryString.category && query.category) {
        this.$store.commit('$_Review/SET_QUERY_STRING', {
          name: 'brands',
          value: '',
        });
        delete query.category;
        this.$router.push({ query: query });
      } else {
        this.$router.push({ query: query });
      }
      this.showFilterCategory = false;
    },
    reset() {
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'category',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'brands',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'origins',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'available_for',
        value: '',
      });
      this.$store.commit('$_Review/SET_QUERY_STRING', {
        name: 'rating',
        value: '',
      });
    },
    checkIsHighlighted(data) {
      if (this.$route.name !== 'Category') {
        if (this.queryString.category == data._id) {
          this.activeChildCategory = true;
          return true;
        }
      } else {
        if (this.$route.params.category_id == data.my_soco_sql_id) {
          this.activeChildCategory = true;
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-grid {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1803921568627451);
  border-radius: 4px;
  padding: 24px;
  background: $white;
  display: flex;
  flex-direction: column;
  // gap: 24px;
  @media (max-width: 991px) {
    padding: 0;
    box-shadow: none;
  }
  .products,
  .product-grid-loading {
    display: grid;
    grid-template-columns: repeat(4, minmax(191px, 1fr));
    gap: 24px;
    &::v-deep {
      .product,
      .product .product__thumb {
        max-width: 169px;
        @media (max-width: 991px) {
          position: relative;
        }
        @media (max-width: 768px) {
          max-width: 100% !important;
        }
      }
      .product__button-review {
        width: 141px;
      }
    }
    @media (max-width: 991px) {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      // max-height: 486px;
      overflow: auto;
    }
  }
  .products-empty {
    text-align: center;
    min-height: 264px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .heading {
      font: 13px/18px $lato_bold;
      letter-spacing: 2px;
      color: #231f20;
      margin: 0 0 6px 0;
    }
    .text {
      // width: 265px;
      font: 18px/26px 'lato-light', sans-serif;
      letter-spacing: 0.69px;
      color: #231f20;
      margin: 10px auto 30px;
      @media (max-width: 991px) {
        font: 14px/20px 'lato-light', sans-serif;
        letter-spacing: 0.54px;
        margin: 10px auto 20px;
      }
    }
  }
  .title-and-sort {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    @media (max-width: 768px) {
      margin-bottom: 0px;
    }
    .title {
      display: flex;
      flex-direction: column;
      > h4 {
        font: 16px/22px $lato_bold;
        letter-spacing: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin: 0;
      }
      > span {
        color: #8c8582;
        white-space: nowrap;
        font: 12px/22px $lato_regular;
        letter-spacing: 0;
      }
    }
    .sort {
      display: flex;
      align-items: center;
      gap: 12px;
      > span {
        color: $greynew;
        white-space: nowrap;
        font: 14px/22px $lato_light;
        letter-spacing: 0;
      }
    }
  }
  .header-filter {
    background-color: #fff;
    position: relative;
    padding: 8px 16px;
    border-radius: 1px;
    .tabs {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;
      list-style-type: none;
      padding: 0;
      margin: 0;
    }
    .tabs::-webkit-scrollbar {
      display: none;
    }
    .tabs__item {
      background-color: #ffffff;
      border: 1px solid #f1f1f1;
      flex: 0 0 auto;
      border-radius: 20px;
      font: 400 12px/16px 'lato-regular', sans-serif;
      padding: 0;
      margin: 0 4px;
      color: #8c8582;
      &:first-child {
        margin-left: 0;
        display: inline-block;
        // margin-right: 15px;
        font-size: 12px;
        text-transform: capitalize;
        > a {
          font-family: 'lato-regular', sans-serif;
        }
      }
      &:last-child {
        margin-right: 0;
      }
      > a {
        display: flex;
        color: #8c8582;
        padding: 9px 12px;
        justify-content: center;
        align-items: center;
        .filter-active {
          &.active {
            color: #231f20;
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
            letter-spacing: 0em;
            text-align: center;
          }
        }

        .icon-filter {
          margin-right: 4px;
          color: #b32656;
          width: 16px;
          height: 16px;
          padding: 5px 3px 3px 3px;
        }
      }
    }
    .tabs__item--no-border {
      border: none;
    }
    .tabs__item__header-filter {
      margin-bottom: 16px;
      &.active {
        background-color: #f384a7;
        border: solid 1px #f384a7;
        > a {
          color: #ffffff;
        }
      }
    }
    .tabs__item__header-filter--with-caret {
      position: relative;
      &:before {
        content: '';
        @include sprite('caret-up');
        background-size: 8px 4px;
        width: 8px;
        height: 10px;
        position: absolute;
        right: 12px;
        top: 10px;
        z-index: 11;
      }
      &:after {
        content: '';
        @include sprite('caret-down');
        background-size: 8px 4px;
        width: 8px;
        height: 10px;
        position: absolute;
        right: 12px;
        bottom: 8px;
        z-index: 11;
      }
      &.active {
        &:before {
          @include sprite('caret-up-white');
        }
        &:after {
          @include sprite('caret-down-white');
        }
        &.up {
          &:after {
            display: none;
          }
        }
        &.down {
          &:before {
            display: none;
          }
        }
      }
      > a {
        padding-right: 32px;
      }
      &.select {
        &:before,
        &:after {
          right: 4px;
        }
        &:after {
          bottom: 10px;
        }
      }
    }
    @media (max-width: 991px) {
      .tabs {
        &:before {
          display: block;
          width: 6px;
          content: '';
          flex-shrink: 0;
        }
        &:after {
          display: block;
          width: 12px;
          content: '';
          flex-shrink: 0;
        }
      }
      .tabs__item {
        > a {
          padding: 9px 12px;
          white-space: nowrap;
        }
      }
      .tabs__item__header-filter--with-caret {
        a {
          padding-right: 28px;
          user-select: none;
        }
        &:before {
          top: 8px;
          left: auto;
          right: 10px;
        }
        &:after {
          right: 10px;
        }
      }
    }
    .all-products {
      display: flex;
      width: 100%;
      padding: 0px 16px 0;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      .subtitle {
        color: #231f20;
        font-family: 'lato-bold', sans-serif;
        font-size: 16px;
        font-style: normal;
        line-height: 22px;
        margin: 0;
        .total-product {
          color: #8c8582;
          font-family: 'lato-regular', sans-serif;
          font-size: 12px;
          font-style: normal;
          margin-left: 5px;
        }
        .icon {
          margin-left: 10px;
        }
      }
    }
  }
}
#sticky_sortby.sticky {
  position: fixed;
  top: 92px;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  padding: 12px 0;
  left: 0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
}

#pills-dropdown-mobile::v-deep {
  .modal-dialog {
    width: 100%;
    margin: 0;
    align-self: flex-end;
    height: max-content;
    max-height: 585px;
    overflow-y: auto;
    border-radius: 18px 18px 0 0;
    .modal-content {
      .modal-header {
        padding: 0;
        .rectangle-top {
          background: #efefef;
          border-radius: 8px;
          height: 3px;
          width: 38px;
          margin: 8px auto;
        }
        .modal-heading {
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0;
          &--title {
            margin-top: 0;
            margin-bottom: 0;
            font-family: 'lato-bold', sans-serif;
            font-size: 14px;
            color: #231f20;
            letter-spacing: normal;
            line-height: 18px;
          }
          &--close {
            position: initial;
            margin-top: 0;
            line-height: 0;
          }
        }
      }
      .modal-body {
        padding: 0;
        .filter-categories {
          border-bottom: 1px solid $greylight;
          ul.parent-category {
            margin-bottom: 0;
            display: flex;
            flex-direction: column;
            gap: 8px;
            > li {
              cursor: pointer;
              position: relative;
              padding: 3px 16px;
              font: 14px/22px $lato_regular;
              letter-spacing: 0;
              text-align: left;
              color: $black;
              &.highlighted {
                background-color: #fff3f3;
                font: 14px/22px $lato_bold;
              }
              &:has(ul.child-category) {
                &::after {
                  content: url('/assets/img/arrow-down-grey.svg');
                  transition: transform 0.4s ease-in;
                  transform: rotate(0deg);
                  position: absolute;
                  right: 16px;
                  top: 0;
                }
              }
              &:has(ul.child-category.active),
              &:has(li.highlighted) {
                &::after {
                  transform: rotate(180deg);
                }
              }
              &.highlighted {
                background-color: #fff3f3;
              }
            }
          }
          ul.child-category {
            max-height: 0;
            transition: all 0.4s ease-in;
            overflow: hidden;
            &.active,
            &:has(li.highlighted) {
              max-height: 250px;
              margin-top: 8px;
            }
          }
        }
      }
    }
  }
}
</style>
